import { Theme, TypographyVariants } from '@mui/material/index.d';
import { createStyled } from '@mui/system';

import { defaultTheme } from '../Theme';

export { chimeIconColorSelectorMap } from './icon';

export const styled = createStyled({ defaultTheme });

export const camelCaseToKebabCase = (str: string) =>
  str.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);

export const getTypographyStyles = (variant: keyof TypographyVariants, theme: Theme): string => {
  const styles = theme.typography[variant];

  return styles
    ? Object.keys(styles).reduce((aggr, key) => {
        // @ts-ignore
        return `${aggr}\n${camelCaseToKebabCase(key)}: ${styles[key]};`;
      }, '')
    : '';
};

export const pad = (value: string) => {
  return value.length === 1 ? '0' + value : value;
};

export const getTimeString = (hour: number, minute: number, format: '12' | '24', am: boolean) => {
  if (format === '12') {
    return hour + ':' + pad(minute.toString()) + ' ' + (am ? 'am' : 'pm');
  } else {
    return hour + ':' + pad(minute.toString());
  }
};

export const buildTimings = (step: number, format: '12' | '24') => {
  let timings = [];
  for (let i = 0; i < 24; i++) {
    let hour = i;
    if (format === '12' && i > 12) {
      hour = i - 12;
    } else if (format === '12' && i === 0) {
      hour = 12;
    }
    for (let j = 0; j < 60; j++) {
      if (j % step === 0) {
        const min = j === 60 ? 0 : j;
        const isAM = i < 12;
        const timeString = getTimeString(hour, min, format, isAM);
        timings.push(timeString);
      }
    }
  }
  return timings;
};
